import React from 'react'
// import useFeatureFlags from 'hooks/useFeatureFlags'
import PageWrapper from 'enrollment-platform/PageWrapper'

export default function BenefitIntegrationsGate({
  children,
}: {
  children: React.ReactNode
}) {
  // const { flags } = useFeatureFlags()
  // if (!flags['ui.benefit-integrations']) {
  //   console.debug('no flag detected')
  // }
  return <PageWrapper>{children}</PageWrapper>
}
